import useCreateCompanyAccessControl, {
  CreateCompanyAccessControlProps,
  translatedCreateCompanyAccessControlProps,
} from 'modules/companies/hooks/use-create-company-access-control';
import usePermissionGroupsForCompaniesSelect from 'modules/permission-groups/hooks/use-permission-groups-for-companies-select-data';
import useUsersSelect from 'modules/users/hooks/use-users-select';
import {useLocation, useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateAccessControl: React.FC = () => {
  const {id} = useParams();
  const {state: workingPeriod} = useLocation();
  const {getSelect, getSwitch, getInput} =
    useFormInputs<CreateCompanyAccessControlProps>();
  const userSelect = useUsersSelect();
  const permissionGroupsSelect = usePermissionGroupsForCompaniesSelect();

  return (
    <Creation
      defaultValues={{active: true, ...(workingPeriod ?? {})}}
      translationKey={translatedCreateCompanyAccessControlProps}
      onSubmit={() => useCreateCompanyAccessControl(id!)}
      inputs={[
        getSwitch({
          name: 'createUser',
        }),
        getSelect({
          name: 'userId',
          data: userSelect.data,
          isLoading: userSelect.isLoading,
          hidden: (data) => !!data.createUser,
        }),
        getInput({
          name: 'user.name',
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.email',
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.password',
          secureText: true,
          hidden: (data) => !data.createUser,
        }),
        getSelect({
          name: 'permissionGroupId',
          data: permissionGroupsSelect.data,
          isLoading: permissionGroupsSelect.isLoading,
        }),
      ]}
      border
    />
  );
};

export default CreateAccessControl;
